// src/components/ui/SheetHeader/index.tsx
import Icon from "../Icon";
import { Header, Titles, Title, Sub, CloseButton } from "./styles";

interface SheetHeaderProps {
  title: string;
  sub?: string;
  onClose: () => void;
}

export default function SheetHeader({ title, sub, onClose }: SheetHeaderProps) {
  return (
    <Header>
      <Titles>
        <Title>{title}</Title>
        {sub && <Sub>{sub}</Sub>}
      </Titles>
      <CloseButton aria-label="Fechar" onClick={onClose}>
        <Icon name="x" size={18} strokeWidth={2.2} />
      </CloseButton>
    </Header>
  );
}
